import { useActiveLayerContext } from '@/context/__project__/ActiveLayerContext'
import { useAdaptiveTextColor, useCompContext, useCompFormContext } from '@/context/__project__/CompContext'

import { CompImageUploadWrapperCore } from '../core/forms/image-upload/wrapper'
import { CompImageUpload } from './CompImageUpload'

/**
 * CompImageUploadWrapper
 */
const CompImageUploadWrapper = () => {
  // infos
  const compContext = useCompContext()
  const { activeLayer } = useActiveLayerContext()
  const { currentParentBg } = useAdaptiveTextColor()
  const infosProps = { ...compContext, currentParentBg, activeLayer }

  // form
  const formContext = useCompFormContext()

  return (
    <CompImageUploadWrapperCore infos={infosProps} form={formContext}>
      {(props) => <CompImageUpload {...props} />}
    </CompImageUploadWrapperCore>
  )
}


export default CompImageUploadWrapper